export const filtro = {
    polizas: [],
    especialidades: [],
    ciudades: [],
    prestadores: [],
    redes: [],
    tipoRedes: [],
};

export const grupos = {
    poliza: "cdPlan",
    red: "red",
    tipoRed: "cdRedCob",
    especialidad: "especialidad",
    ciudad: "ciudad",
    prestador: "nombreProveedor",
    todos: "todos",
};

export const gruposList = [
    { label: "Todos", value: grupos.todos },
    { label: "Póliza", value: grupos.poliza },
    { label: "Red", value: grupos.red },
    { label: "Nombre de red", value: grupos.tipoRed },
    { label: "Especialidad", value: grupos.especialidad },
    { label: "Ciudad", value: grupos.ciudad },
    { label: "Prestador", value: grupos.prestador },
];

const green = "#006465";
const yellow = "#F2F59D";
const gris = "#DEDEDE";

export const customStyles = {
    option: (provided, { isDisabled, isFocused, isSelected }) => ({
        ...provided,
        color: green,
        backgroundColor: isFocused ? gris : undefined,
    }),
    control: (provided, state) => ({
        border: "1px solid " + green,
        background: "white",
        display: "flex",
    }),
    menu: (provided, state) => ({
        ...provided,
        zIndex: "2",
    }),
};
